export default __webpack_public_path__ + "static/media/ecologistic.d86d236c.ico";